import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

import { LazyLoadImage } from "react-lazy-load-image-component";

const Home = ({ prod }) => {
	const classes = useStyles();
	let navigate = useNavigate();
	console.log(prod);

	const handleClick = (page) => {
		navigate("/product/page=" + page);
	};
	return (
		<Container>
			<Box className={classes.product__inner}>
				<Grid container sx={{ width: 1 }}>
					<Grid item md={12}>
						<Typography variant="h4" className="title">
							Home Fragrance
						</Typography>
						<Typography color="gray">
							We are proudly presenting our powerful cleansing & disinfecting
							products.
						</Typography>
					</Grid>
					<Grid item md={6} sx={{ paddingLeft: { md: "100px", sm: 0 } }}>
						<Grid
							container
							className={classes.product__content}
							sx={{ paddingTop: "20px", flexDirection: "column" }}
						>
							<Grid item sx={{ width: 3 / 4 }}>
								<LazyLoadImage
									className={classes.product__img}
									height="300"
									alt={process.env.PUBLIC_URL + "/img/candle.png"}
									src={process.env.PUBLIC_URL + "/img/candle.png"}
									style={{ borderRadius: "20px", border: "1px solid #e0e0e0" }}
								/>
							</Grid>
							<Grid item sx={{ width: 3 / 4 }}>
								<CardContent>
									<Typography
										sx={{ fontSize: 14 }}
										color="text.secondary"
										gutterBottom
									>
										Heslet
									</Typography>
									<Typography
										variant="h5"
										component="div"
										sx={{ fontWeight: "bold", fontSize: "23px" }}
									>
										Bio Candle
									</Typography>
									<Typography color="text.secondary">
										Eliminate odors & fresh fragnant oil
									</Typography>
								</CardContent>
								<Button size="small" variant="contained" color="secondary">
									Learn More
								</Button>
							</Grid>
						</Grid>
					</Grid>
					<Grid item md={6} sx={{ paddingRight: { md: "100px", sm: 0 } }}>
						<Grid
							container
							className={classes.product__content}
							sx={{ paddingTop: "20px", flexDirection: "column" }}
						>
							<Grid item sx={{ width: 3 / 4 }}>
								<LazyLoadImage
									className={classes.product__img}
									height="300"
									alt={process.env.PUBLIC_URL + "/img/diffuser.png"}
									src={process.env.PUBLIC_URL + "/img/diffuser.png"}
									style={{ borderRadius: "20px", border: "1px solid #e0e0e0" }}
								/>
								{/* <CardMedia
									component="img"
									height="290"
									image={process.env.PUBLIC_URL + "/img/product_03.png"}
									alt="Paella dish"
									sx={{ objectFit: "cover" }}
								/> */}
							</Grid>
							<Grid item sx={{ width: 3 / 4 }}>
								<CardContent>
									<Typography
										sx={{ fontSize: 14 }}
										color="text.secondary"
										gutterBottom
									>
										Heslet
									</Typography>
									<Typography
										variant="h5"
										component="div"
										sx={{ fontWeight: "bold", fontSize: "23px" }}
									>
										Bio Diffuser
									</Typography>
									<Typography color="text.secondary">
										Eliminate odors & fresh fragnant oil
									</Typography>
								</CardContent>
								<Button size="small" variant="contained" color="secondary">
									Learn More
								</Button>
							</Grid>
						</Grid>
					</Grid>
					<Grid item md={12}>
						<Typography variant="h4" className="title">
							Warmer and Electronic Diffuser
						</Typography>
						<Typography color="gray">
							We are proudly presenting our powerful cleansing & disinfecting
							products.
						</Typography>
					</Grid>
					<Grid item md={6} sx={{ paddingLeft: { md: "100px", sm: 0 } }}>
						<Grid
							container
							className={classes.product__content}
							sx={{ paddingTop: "20px", flexDirection: "column" }}
						>
							<Grid item sx={{ width: 3 / 4 }}>
								<LazyLoadImage
									className={classes.product__img}
									height="300"
									alt={process.env.PUBLIC_URL + "/img/figure.png"}
									src={process.env.PUBLIC_URL + "/img/figure.png"}
									style={{ borderRadius: "20px", border: "1px solid #e0e0e0" }}
								/>
							</Grid>
							<Grid item sx={{ width: 3 / 4 }}>
								<CardContent>
									<Typography
										sx={{ fontSize: 14 }}
										color="text.secondary"
										gutterBottom
									>
										Heslet
									</Typography>
									<Typography
										variant="h5"
										component="div"
										sx={{ fontWeight: "bold", fontSize: "23px" }}
									>
										Figure Candle Warmer
									</Typography>
									<Typography color="text.secondary">
										Fresh fragnant & Edge interior item
									</Typography>
								</CardContent>
								<Button size="small" variant="contained" color="secondary">
									Learn More
								</Button>
							</Grid>
						</Grid>
					</Grid>
					<Grid item md={6} sx={{ paddingRight: { md: "100px", sm: 0 } }}>
						<Grid
							container
							className={classes.product__content}
							sx={{ paddingTop: "20px", flexDirection: "column" }}
						>
							<Grid item sx={{ width: 3 / 4 }}>
								<LazyLoadImage
									className={classes.product__img}
									height="300"
									alt={process.env.PUBLIC_URL + "/img/air.png"}
									src={process.env.PUBLIC_URL + "/img/air.png"}
									style={{ borderRadius: "20px", border: "1px solid #e0e0e0" }}
								/>
								{/* <CardMedia
									component="img"
									height="290"
									image={process.env.PUBLIC_URL + "/img/product_03.png"}
									alt="Paella dish"
									sx={{ objectFit: "cover" }}
								/> */}
							</Grid>
							<Grid item sx={{ width: 3 / 4 }}>
								<CardContent>
									<Typography
										sx={{ fontSize: 14 }}
										color="text.secondary"
										gutterBottom
									>
										Heslet
									</Typography>
									<Typography
										variant="h5"
										component="div"
										sx={{ fontWeight: "bold", fontSize: "23px" }}
									>
										Smart Diffuser
									</Typography>
									<Typography color="text.secondary">
										Eliminate odors & fresh fragnant oil
									</Typography>
								</CardContent>
								<Button size="small" variant="contained" color="secondary">
									Learn More
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</Container>
	);
};

export default Home;

const useStyles = makeStyles({
	product: {},
	product__inner: {
		textAlign: "center",
		paddingTop: "40px",
	},
	product__content: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		marginBottom: "70px",
	},
	product__img: {
		maxWidth: "500px",
		minWidth: "200px",
		borderRadius: "2%",
		cursor: "pointer",
	},
});
